
        // Import the welcome screen module
        import { initWelcomeScreen, resizeWelcomeScreen, disposeWelcomeScreen, startTransitionOut } from './src/welcomeScreen.ts';
        import { AudioManager } from './src/audioManager.ts';
        import { SettingsManager } from './src/settingsManager.ts';
        import { createMedievalButton, createSettingsDialog, showSettingsDialog, createCreditsDialog, showCreditsDialog, createCookieConsentDialog } from './src/uiComponents.ts';

        // Initialize settings manager
        const settingsManager = SettingsManager.getInstance();
        
        // Initialize audio manager immediately
        const audioManager = AudioManager.getInstance();
        
        // Function to handle UI fade in
        function fadeInUI() {
            document.getElementById('game-logo').style.opacity = '1';
            document.getElementById('game-subtitle').style.opacity = '1';
            document.getElementById('version').style.opacity = '1';
            
            // Find start button
            const startButton = document.querySelector('#start-button-container button');
            if (startButton) {
                startButton.style.opacity = '1';
            }
        }
        
        // Initialize the welcome screen when the page loads
        window.addEventListener('DOMContentLoaded', async () => {
            const previewContainer = document.getElementById('dungeon-preview');
            
            if (previewContainer) {
                // Initialize the welcome screen
                await initWelcomeScreen(previewContainer);
                
                // Initialize audio system
                await audioManager.init();

                // Check if cookie consent has been given before
                if (!settingsManager.hasConsentBeenGiven()) {
                    // Create and show the cookie consent dialog
                    const { overlay } = createCookieConsentDialog(() => {
                        // Play menu music after user accepts cookies (using this as our gesture)
                        if(settingsManager.isStorageAllowed() && audioManager.isMusicEnabled()) {   
                            audioManager.playMenuMusic();
                        }
                    });
                    document.body.appendChild(overlay);
                } else if (settingsManager.isStorageAllowed() && audioManager.isMusicEnabled()) {
                    // If consent was already given and music is enabled, try to play menu music
                    // This might still be blocked by browsers until a user interacts with the page
                    setTimeout(() => {
                        const playButton = document.createElement('button');
                        playButton.style.display = 'none';
                        document.body.appendChild(playButton);
                        playButton.addEventListener('click', () => {
                            audioManager.playMenuMusic();
                            playButton.remove();
                        });
                        playButton.click();
                    }, 1000);
                }
                
                // Create start button
                const startButtonContainer = document.getElementById('start-button-container');
                const startButton = createMedievalButton('Start Game', () => {
                    // Fade out the welcome overlay
                    const welcomeOverlay = document.getElementById('welcome-overlay');
                    welcomeOverlay.style.opacity = '0';
                    
                    // Start the transition animation
                    startTransitionOut();
                    
                    // Fade out menu music if it's playing
                    if (audioManager.isInitialized && audioManager.isMusicEnabled()) {
                        audioManager.fadeOutMusic(2000);
                    }
                    
                    // Hide the settings button in the top left corner
                    const settingsButtonContainer = document.getElementById('settings-button-container');
                    if (settingsButtonContainer) {
                        settingsButtonContainer.style.display = 'none';
                    }

                    // Hide the credits button in the top left corner
                    const creditsButtonContainer = document.getElementById('credits-button-container');
                    if (creditsButtonContainer) {
                        creditsButtonContainer.style.display = 'none';
                    }

                    // Hide the version in the top right corner
                    const version = document.getElementById('version');
                    if (version) {
                        version.style.display = 'none';
                    }
                    
                    // Wait for transition to complete before switching screens
                    setTimeout(() => {
                        // Remove the entire welcome screen
                        const welcomeScreen = document.getElementById('welcome-screen');
                        welcomeScreen.remove();
                        
                        document.getElementById('game-container').style.display = 'block';
                        document.getElementById('loading-indicator').style.display = 'flex';
                        document.getElementById('version').style.display = 'none';
                        
                        // Dispose of the welcome screen to free up resources
                        disposeWelcomeScreen();
                        
                        // Import and initialize the game
                        import('./src/main.ts').then(() => {
                            // Fade out loading indicator smoothly
                            const loadingIndicator = document.getElementById('loading-indicator');
                            loadingIndicator.style.transition = 'opacity 0.5s ease-out';
                            loadingIndicator.style.opacity = '0';
                            setTimeout(() => {
                                loadingIndicator.style.display = 'none';
                            }, 500);
                        }).catch(error => {
                            console.error('Failed to load game:', error);
                            document.getElementById('loading-indicator').innerHTML = '<div class="loading-text">Failed to load game. Please refresh.</div>';
                        });
                    }, 1000); 
                });
                
                // Ensure button has the right transition and is hidden initially
                startButton.style.transition = 'opacity 1s ease-out'; 
                startButton.style.opacity = '0';
                startButtonContainer.appendChild(startButton);
                
                // Create settings button
                const settingsButtonContainer = document.getElementById('settings-button-container');
                const settingsButton = createMedievalButton('Settings', () => {
                    const dialog = document.getElementById('settings-dialog');
                    if (dialog) {
                        showSettingsDialog(dialog);
                    }
                }, true);
                settingsButtonContainer.appendChild(settingsButton);

                // Create credits button
                const creditsButtonContainer = document.getElementById('credits-button-container');
                const creditsButton = createMedievalButton('Credits', () => {
                    const dialog = document.getElementById('credits-dialog');
                    if (dialog) {
                        showCreditsDialog(dialog);
                    }
                }, true);
                creditsButtonContainer.appendChild(creditsButton);

                // Create settings dialog
                const settingsDialog = createSettingsDialog();
                document.body.appendChild(settingsDialog);

                // Create credits dialog
                const creditsDialog = createCreditsDialog();
                document.body.appendChild(creditsDialog);
                
                // Handle window resize
                window.addEventListener('resize', () => {
                    resizeWelcomeScreen(window.innerWidth, window.innerHeight);
                });
                
                // Ensure the font is loaded before fading in UI
                document.fonts.ready.then(() => {
                    // Ensure all DOM elements are ready, then fade in
                    setTimeout(fadeInUI, 300);
                });
            }
        });
    